export interface TaxonomyItem {
  id?: string;
  area: string;
  kind: string;
  type: string;
  classification: string;
}

export const DEFAULT_TAXONOMY_ITEMS: TaxonomyItem[] = [
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "ATC Congestion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "ATC English"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "ATC Service Standard"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Barometric Information Error"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Callsign Confusion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Communication with ATC Lost"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Inadequate Separation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Landing Clearance Errors"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Met Info/Briefing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Military Influence"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Air Traffic Management",
    "classification": "Take off Clearance Errors"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Airport Closed"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Airport Congestion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Airport Fire Service"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Approach/Landing System Events (ILS, LOC, VOR, NDB, PAPI, VASI, etc.)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Bird/Animal Control (excluding Bird/Animal Strike)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "FOD (Runway/Taxiway)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Parking Guidance Control"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Ramp - Lighting"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Ramp - Markings"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Runway - Contamination"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Runway - Lighting"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Runway - Markings"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Runway - Surface Conditions"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Runway Excursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Runway Incursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Service/Facilities Deficiencies"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Contamination"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Lighting"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Markings"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Surface Conditions"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway Incursion by Ground Vehicle"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Bird or Other Wildlife Strike",
    "classification": "Birdstrike"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Bird or Other Wildlife Strike",
    "classification": "Wildlife Strike"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - False Warning"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - Flaps"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - Gear"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - Not Specific"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - Speedbrake"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Configuration - Trim"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Configuration Warnings",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Coordination/Communications",
    "classification": "Flight Crew - ATC"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "CRM",
    "classification": "CRM - Awareness"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "CRM",
    "classification": "CRM - Decision"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "CRM",
    "classification": "CRM - Dexterity"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "CRM",
    "classification": "CRM - Distraction"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Aircraft Library"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Aircraft Technical Log (ETL)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Approach Charts"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Company Operations Manuals"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Electronic Flight Bag (EFB)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Emergency Checklists"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Flight Plan"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "FMS,FMGS/RNAV Data"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Fuel Plan"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Loadsheet Compilation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Maps"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "MEL"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Meteorological Data"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Navigation Charts"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Non-Normal Checklists"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Normal Checklist"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "NOTAM"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "NOTOC"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Documentation/Data",
    "classification": "Other Operational Data"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Bankangle"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Don't Sink"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "False GPWS Alert due to Loss of GPS"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "False Warning"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Gear/Flap"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Glideslope"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Pull Up"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Sink Rate"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "System Limitation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Terrain Closure"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "EGPWS/GPWS",
    "classification": "Windshear"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Environmental",
    "classification": "Physical Environment"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Environmental",
    "classification": "Weather"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Fire - Cabin"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Fire - Cockpit"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Fumes/Odor - Cabin"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Fumes/Odor - Cockpit"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Smoke - Cabin"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Fire/Smoke/Fumes",
    "classification": "Smoke - Cockpit"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Aircraft Collision with Vehicle/Equipment"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Aircraft Ground Collision with Other Aircraft"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Aircraft Limit Exceedance"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Airprox"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "ATC Violation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Checklist/SOP Use"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Deep Landing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "False RAAS Alert due to Loss of GPS"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Automation Errors"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Approach"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Climb"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Cruise"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Go Around"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Landing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Tail Strike"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Manual Handling - Takeoff"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Crew Mis-Selection"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Flight Deck Procedures"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Fuel Management"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Go Around"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "GPS Loss"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Ground Taxi Speed Exceedance"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Handling of Technical Failures"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Hard/Heavy Landing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "High Bank Angle"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Jet Blast - Encountered"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Jet Blast - Generated"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Rejected Takeoff (RTO)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Unreliable speed"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Approach Path Management"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Checklist Error"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Configuration Error"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - High Energy"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Low Energy"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "TCAS Spoofing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Management",
    "classification": "Workload Management"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Aircraft Limit Exceedence"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Aircraft Upset"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Altitude Deviation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Approach"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Flight Path Deviation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Landing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Long Landing Monitor"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Overspeed/Low Speed Warning"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Pushback Violation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Runway Excursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Runway Incursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Runway Safety Systems"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Stable Approach Monitor"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Take-off"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Take-off Flap Config"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Taxiway Excursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Taxiway Incursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Temporary Loss of control"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Path Management",
    "classification": "Terrain/Obstacle Conflict (TAWS)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Planning and Preparation",
    "classification": "Flight Plan"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Planning and Preparation",
    "classification": "Fuel Management"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Planning and Preparation",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Flight Planning and Preparation",
    "classification": "Performance Calculations"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Crew Illness"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Crew Incapacitation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Crew Injury"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Suspected Food Poisoning"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Miscellaneous",
    "classification": "Laser Pointer/Kite/Drone/Balloon"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Miscellaneous",
    "classification": "Miscellaneous"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Dangerous Goods/Security"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Ditching"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Emergency Declaration"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Emergency Descent"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Emergency Landing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Fuel Jettison"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Non-Normal Disembarkation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Non-Normal Engine Operation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Air Turnback"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Ambulance/Paramedic"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Diversion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Fire Fighting in Flight"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Fire Services Called on Ground"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Flight Cancelled"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Operational Impact",
    "classification": "Return to Stand"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Performance Calculations",
    "classification": "Performance Issues"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Performance Calculations",
    "classification": "Weight and Balance Irregularity"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Physically Abusive"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Verbally Abusive"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Passenger smoking onboard"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Crosswind"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Fog"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Hail"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Insufficient Visual Reference"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Lightning Strike"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Microburst"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Sandstorm"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Severe Icing"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Severe Weather"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Tailwind"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Thunderstorm"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Turbulence"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Weather",
    "classification": "Windshear"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Injury",
    "classification": "Crew Injury"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Injury",
    "classification": "Passenger Injury"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Occurrence Report",
    "type": "Injury",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Commander Discretion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Consecutive Flights"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Crew Fatigue/Stress"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Disruptive Schedule"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Duty Change"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Duty Extension"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Hotel/Transportation Problems"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Long Day Duty"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Long Night Duty"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Minimum Rest Time"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Other Roster Issues"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Roster"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Sleep Disturbed"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Split Duty or Long Waiting at Ground"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Crew Fatigue/Stress"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Individual Reasons"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Roster"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Sleep Disturbed"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Staff Fatigue/Stress"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Other"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Shift"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Extension of Flight Duty Period",
    "type": "Flight / Duty Time Limitations",
    "classification": "Exceedance of Flight / Duty Period"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Air Traffic Management",
    "classification": "Take off Clearance Errors"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Contamination"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Lighting"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Markings"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway - Surface Conditions"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Airport Management/Infrastructure",
    "classification": "Taxiway Incursion by Ground Vehicle"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Bird or Other Wildlife Strike",
    "classification": "Wildlife Strike"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "EGPWS/GPWS",
    "classification": "System Limitation"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "EGPWS/GPWS",
    "classification": "Terrain Closure"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "EGPWS/GPWS",
    "classification": "Windshear"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "External Influence - Other Airborne",
    "classification": "Unmanned Aerial Vehicles"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Unreliable speed"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Approach Path Management"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Checklist Error"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Configuration Error"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - High Energy"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Unstabilized Approach - Low Energy"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Management",
    "classification": "Workload Management"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Path Management",
    "classification": "Take-off"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Path Management",
    "classification": "Take-off Flap Config"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Path Management",
    "classification": "Taxiway Excursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Path Management",
    "classification": "Taxiway Incursion"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Path Management",
    "classification": "Temporary Loss of control"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Flight Path Management",
    "classification": "Terrain/Obstacle Conflict (TAWS)"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Weather",
    "classification": "Tailwind"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Weather",
    "classification": "Thunderstorm"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Weather",
    "classification": "Turbulence"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Weather",
    "classification": "Windshear"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Individual Actions"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Temperature"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Visibility"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Weather"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Skill-Based Errors"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "Sensory Misperception"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "State of Mind"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Misconduct"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Violations"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Uncorrected Problem"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Delays",
    "classification": "ATC Delay"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Delays",
    "classification": "Crew Delay"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Delays",
    "classification": "Maintenance Delay"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Delays",
    "classification": "Late inbound aircraft"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Cancellations"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Diversions"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Fuel Related Issues"
  },
  {
    "area": "Air Safety Report (ASR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "After Passenger Disembarkation"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Boarding"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Cabin Crew Performance"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Cabin Documentation"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Cruise"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Departure and Taxi"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Descent"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Flight Deck Access"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Landing"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Pre-Flight"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Proactive Safety Report"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Take-off and Climb"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Cabin Crew Harness"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Cabin Crew Seat"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Cabin Fixtures"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Escape Path Lighting System"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Exit Marking/Signs"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Fold Down Tables"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Fridge/Cooler"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Galley Chilling Systems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Oven"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Passenger Seat"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Seatbelt"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Seatbelt Extender"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Seats and Associated Restraints"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Shower/Spa"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Trash Compactor"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Water/Liquid Waste System"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "Animals in the Cabin"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "Cabin Baggage"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "Crew Complement"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "In-Flight Turbulence"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "Medical Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "PED Fallen in Seat"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Management",
    "classification": "Performance"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Circuit Breaker"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Crash/Fire Axe"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Demo Kit"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Emergency Locator Transmitter"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Escape Slide/Raft"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Fire Extinguishing Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Flashlight/Torch"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Infant Flotation Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Lifejackets"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Location"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Malfunctions"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Megaphone"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Missing Safety Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Portable Fire Extinguishers"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Portable Oxygen"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Protective Breathing Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Recommendations"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Repeating Malfunctions"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Restraint Kit"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Safety Information Cards"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Smoke Alert"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Supplementary Survival Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Used in Occurrence"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Cart"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Dry Stores"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Foldable Trolley"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Glassware"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Hot Beverage Container"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Oven Insert"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cabin Service Equipment",
    "classification": "Supplemental Hygiene Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Catering Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Catering Loading"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Crew Meal/Payment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Meal Hygiene"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Meal Quality"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cleaning",
    "classification": "Insufficient"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Cleaning",
    "classification": "Other Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Crew",
    "classification": "Crew Errors"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Crew Bus",
    "classification": "Cobus/Apron Shuttle"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Crew Bus",
    "classification": "Crew Transportation"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Crew Planning",
    "classification": "Crew Tracking Issues"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Crew Planning",
    "classification": "Insufficient Ground Time"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Crew Planning",
    "classification": "Planning Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Door Arming"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Door Disarming"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Door Mode Selector"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Door Obstruction"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Door Open"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Inadvertent Slide Deployment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Manning/Monitoring Procedures"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Normal Door Closing"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Normal Door Opening"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Door/Exit",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Flight Feedback",
    "classification": "Ground Handling Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Flight Feedback",
    "classification": "Operational Divert"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Flight Feedback",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Flight Feedback",
    "classification": "Technical Difficulties"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Flight Feedback",
    "classification": "Water/Waste Service"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Flight Feedback",
    "classification": "WCH Service Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Hotel",
    "classification": "Hotel Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Catering Material Injuries"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Crew Illness"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Medical",
    "classification": "Passenger Illness"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Operational Feedback",
    "classification": "Feedback"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Passenger Feedback",
    "classification": "Feedback"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Observations",
    "classification": "Observations"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Recommendations",
    "classification": "Operational"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Violations",
    "classification": "Crew"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Violations",
    "classification": "Ground Equipment"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Violations",
    "classification": "Ground Personnel"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Violations",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Safety Violations",
    "classification": "Passenger"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Seating Problems",
    "classification": "DCS Related"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Seating Problems",
    "classification": "Ground Related"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Seating Problems",
    "classification": "Operational"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Seating Problems",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Seating Problems",
    "classification": "Passenger Related"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Intoxication"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Life Threatening Behaviour"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Non-Compliance"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Other"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Physically Abusive"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Occurrence Report",
    "type": "Unruly Passenger",
    "classification": "Verbally Abusive"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Cabin Crew Normal Procedures",
    "classification": "Take-off and Climb"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Trash Compactor"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Cabin Fixed Equipment",
    "classification": "Water/Liquid Waste System"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Cabin Safety/Emergency Equipment",
    "classification": "Used in Occurrence"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Flight Feedback",
    "classification": "Technical Difficulties"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Flight Feedback",
    "classification": "Water/Waste Service"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Flight Feedback",
    "classification": "WCH Service Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Unruly Passenger",
    "classification": "Verbally Abusive"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Individual Actions"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Temperature"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Visibility"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Weather"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Skill-Based Errors"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "Sensory Misperception"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "State of Mind"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Misconduct"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Violations"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Uncorrected Problem"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Commander Discretion"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Consecutive Flights"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Crew Fatigue/Stress"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Disruptive Schedule"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Duty Change"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Duty Extension"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Hotel/Transportation Problems"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Long Day Duty"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Long Night Duty"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Minimum Rest Time"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Other Roster Issues"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Sleep Disturbed"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Split Duty or Long Waiting at Ground"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Crew Fatigue/Stress"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Individual Reasons"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Roster"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Fatigue Report",
    "type": "Unfit to Fly",
    "classification": "Sleep Disturbed"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Operational Irregularity Report",
    "type": "Delays",
    "classification": "Late Reporting / No-show"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Operational Irregularity Report",
    "type": "Delays",
    "classification": "Inadequate Crew Complement"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Crew procedural error"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Crew conflict / interpersonal issue"
  },
  {
    "area": "Cabin Safety Report (CSR)",
    "kind": "Operational Irregularity Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Cabin Door"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Cargo Door"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Cargo Hold"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Engine"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Fuselage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Horizontal/Vertical Stabiliser"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Landing Gear"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Lights"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Damage",
    "classification": "Wings"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "A/C incorrectly released"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "AD Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Approved Maintenance Programs"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Bleed Air Leak"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "CRS missing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "CRS not issued"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Damage primary structure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Damage secondary structure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Defect Deferral"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Defect ground equipment"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Defect Life/Time Controlled Part"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Deferred Item not reported"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Documents missing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Failure emergency system/equipment"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Incorrect Assembly"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Incorrect maintenance data"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Maintenance Accomplishment"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "MEL"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Mistake in Work Report"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Non compliance maintenance procedure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "SB Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Structural"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Tasks not Performed as WP"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "Unknown or Suspect Origin of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Airworthiness Review",
    "classification": "WP not Received in Due Time"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Birdstrike",
    "classification": "Birdstrike"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "AD Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Airworthiness Data Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Component Requirement Overdue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Component Tracing (PN/SN/Position)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Configuration Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Documentation/Records"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "FH/FC Counter Incorrect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "In-service Data Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Incorrect maintenance data"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Life Expired Component"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "MEL Preparation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Modification Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Time Controlled Part Exceedance"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Engineering",
    "classification": "Unapproved Repair"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Cleanliness"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Hazardous/Toxic Substances"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "High Noise Levels"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Hot/Cold/Humidity"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Inadequate Ventilation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Lighting"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Rain/Snow"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Environment/Facilities",
    "classification": "Wind/Storm"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 12 Servicing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 21 Air Conditioning & Pressurisation System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 22 Auto Flight"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 23 Communications"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 24 Electrical Power"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 25 Equipment/Furnishings"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 26 Fire Protection"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 27 Flight Controls"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 28 Fuel"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 29 Hydraulic Power"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 30 Ice & Rain Protection"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 31 Indicating & Recording System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 32 Landing Gear"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 33 Lights"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 34 Navigation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 35 Oxygen"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 36 Pneumatics"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 38 Water/Waste"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 46 Information System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 47 Inert Gas System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 49 Auxiliary Power Unit (APU)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 52 Doors"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 53 Fuselage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 54 Nacelles/Pylons"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 55 Stabilizers"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 56 Windows"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 57 Wings"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 71 Powerplant"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 72 Engine"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 73 Engine Fuel and Control"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 74 Ignition"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 75 Air"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 76 Engine Controls"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 77 Engine Indicating"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 78 Exhaust"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 79 Oil"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "ATA 80 Starting"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Activity",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Airplane/Equipment Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Foreign Object Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Inadvertent Activation Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Installation Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Maintenance Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Personal Injury"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Repair Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Servicing Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Test/Inspection Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Error",
    "classification": "Tool/GSE Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Airworthiness Control Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Continuing Airworthiness Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Fault Isolation/Test/Inspection"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Foreign Object Damage Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Installation Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Repair Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Servicing Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Supply Issue/Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management",
    "classification": "Vendor Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Management System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Organizational Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Tech Ops Standard Practices"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Depressurization"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Fire Detected or Protected"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Smoke and/or Fumes"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "ADHOCJIC Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Airworthiness Directive Overrun"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "AMOS Entry or Update Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Component Robbery Control"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Defect Beyond Limits"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Flight with Open Defect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Inadequate Manhour"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Incorrectly Deferred Defect (Time interval)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Ineffective Part on Board Aircraft"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Maintenance Check/Task Planning Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Maintenance Data Unapproved/Missing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Maintenance Task not Correctly Documented"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "MEL/CDL Evaluation/Application"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Records Control"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Report Back Omitted/Wrong"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Scheduled Task Omitted/Late Performed"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Significant Spares Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Tasks not Performed as WP"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Technical log oversight"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Time Expired Part on Board Aircraft"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Tool Planning Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Planning",
    "classification": "Unauthorized Maintenance Certification"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Reliability",
    "classification": "AMP Discrepancy"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Reliability",
    "classification": "NFF Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Reliability",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Reliability",
    "classification": "Significant Recurring Defect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Reliability",
    "classification": "Unreliable Component"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Air Data Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Aircraft Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Bleed Air Leak"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Braking and Steering"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Damage primary structure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Depressurization"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Emergency Equipment Failure/Overdue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Engine Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Fire Detected or Protected"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Flight Control Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Flight with Open Defect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Fluid leak"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Overheat"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Smoke and/or Fumes"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Significant Technical Event",
    "classification": "Vibration/Rattle/Noise"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Certification Missing/Wrong"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Hazardous Waste Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Inventory Record Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Mutilation of Components"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Part Damaged"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Part Lost"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Pool Agreement"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Receiving Inspection Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Segregation of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Stock Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Unknown or Suspect Origin of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Store",
    "classification": "Unusual Defect of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Toolstore",
    "classification": "Calibration Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Toolstore",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Toolstore",
    "classification": "Tool Lost"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Design Error (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Early Failures (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Incorrect Installation (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Incorrect Parts Used (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Incorrect Servicing (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Wildlife Strike",
    "classification": "Wildlife Strike"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "AD Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Component Requirement Overdue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Component Tracing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Environment/Facilities"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Equipment Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Human Factor/Fatigue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Incoming Inspection Finding"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Incorrect maintenance data"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Inventory Record Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Life Expired Part"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Maintenance Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Modification Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Segregation of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Technical Record"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Unapproved Repair/Misapplication"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Unknown or Suspect Origin of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Occurrence Report",
    "type": "Workshop",
    "classification": "Unusual Defect of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Cabin Door"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Cargo Door"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Cargo Hold"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Engine"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Fuselage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Horizontal/Vertical Stabiliser"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Landing Gear"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Lights"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Aircraft Damage",
    "classification": "Wings"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "A/C incorrectly released"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "AD Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Approved Maintenance Programs"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Bleed Air Leak"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "CRS missing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "CRS not issued"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Damage primary structure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Damage secondary structure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Defect Deferral"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Defect ground equipment"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Defect Life/Time Controlled Part"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Deferred Item not reported"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Documents missing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Failure emergency system/equipment"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Incorrect Assembly"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Incorrect maintenance data"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Maintenance Accomplishment"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "MEL"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Mistake in Work Report"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Non compliance maintenance procedure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "SB Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Structural"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Tasks not Performed as WP"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "Unknown or Suspect Origin of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Airworthiness Review",
    "classification": "WP not Received in Due Time"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Birdstrike",
    "classification": "Birdstrike"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "AD Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Airworthiness Data Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Component Requirement Overdue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Component Tracing (PN/SN/Position)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Configuration Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Documentation/Records"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "FH/FC Counter Incorrect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "In-service Data Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Incorrect maintenance data"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Life Expired Component"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "MEL Preparation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Modification Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Time Controlled Part Exceedance"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Engineering",
    "classification": "Unapproved Repair"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Cleanliness"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Hazardous/Toxic Substances"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "High Noise Levels"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Hot/Cold/Humidity"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Inadequate Ventilation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Lighting"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Rain/Snow"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environment/Facilities",
    "classification": "Wind/Storm"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 12 Servicing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 21 Air Conditioning & Pressurisation System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 22 Auto Flight"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 23 Communications"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 24 Electrical Power"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 25 Equipment/Furnishings"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 26 Fire Protection"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 27 Flight Controls"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 28 Fuel"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 29 Hydraulic Power"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 30 Ice & Rain Protection"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 31 Indicating & Recording System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 32 Landing Gear"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 33 Lights"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 34 Navigation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 35 Oxygen"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 36 Pneumatics"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 38 Water/Waste"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 46 Information System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 47 Inert Gas System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 49 Auxiliary Power Unit (APU)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 52 Doors"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 53 Fuselage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 54 Nacelles/Pylons"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 55 Stabilizers"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 56 Windows"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 57 Wings"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 71 Powerplant"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 72 Engine"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 73 Engine Fuel and Control"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 74 Ignition"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 75 Air"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 76 Engine Controls"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 77 Engine Indicating"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 78 Exhaust"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 79 Oil"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "ATA 80 Starting"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Activity",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Airplane/Equipment Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Foreign Object Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Inadvertent Activation Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Installation Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Maintenance Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Personal Injury"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Repair Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Servicing Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Test/Inspection Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Error",
    "classification": "Tool/GSE Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Airworthiness Control Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Continuing Airworthiness Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Fault Isolation/Test/Inspection"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Foreign Object Damage Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Installation Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Repair Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Servicing Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Supply Issue/Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management",
    "classification": "Vendor Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Management System"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Organizational Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Maintenance Program Management - Organization",
    "classification": "Tech Ops Standard Practices"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Depressurization"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Fire Detected or Protected"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Non-Normal Procedures and Emergency Procedures",
    "classification": "Smoke and/or Fumes"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "ADHOCJIC Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Airworthiness Directive Overrun"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "AMOS Entry or Update Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Component Robbery Control"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Defect Beyond Limits"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Flight with Open Defect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Inadequate Manhour"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Incorrectly Deferred Defect (Time interval)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Ineffective Part on Board Aircraft"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Maintenance Check/Task Planning Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Maintenance Data Unapproved/Missing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Maintenance Task not Correctly Documented"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "MEL/CDL Evaluation/Application"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Records Control"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Report Back Omitted/Wrong"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Scheduled Task Omitted/Late Performed"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Significant Spares Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Tasks not Performed as WP"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Technical log oversight"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Time Expired Part on Board Aircraft"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Tool Planning Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Planning",
    "classification": "Unauthorized Maintenance Certification"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Reliability",
    "classification": "AMP Discrepancy"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Reliability",
    "classification": "NFF Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Reliability",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Reliability",
    "classification": "Significant Recurring Defect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Reliability",
    "classification": "Unreliable Component"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Air Data Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Aircraft Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Bleed Air Leak"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Braking and Steering"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Damage primary structure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Depressurization"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Emergency Equipment Failure/Overdue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Engine Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Fire Detected or Protected"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Flight Control Failures"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Flight with Open Defect"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Fluid leak"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Overheat"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Smoke and/or Fumes"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Significant Technical Event",
    "classification": "Vibration/Rattle/Noise"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Certification Missing/Wrong"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Hazardous Waste Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Inventory Record Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Mutilation of Components"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Part Damaged"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Part Lost"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Pool Agreement"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Receiving Inspection Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Segregation of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Stock Management"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Unknown or Suspect Origin of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Store",
    "classification": "Unusual Defect of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Toolstore",
    "classification": "Calibration Issue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Toolstore",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Toolstore",
    "classification": "Tool Lost"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Design Error (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Early Failures (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Incorrect Installation (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Incorrect Parts Used (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Incorrect Servicing (vendor)"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Vendor/Manufacturer Error",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Wildlife Strike",
    "classification": "Wildlife Strike"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "AD Evaluation"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Component Requirement Overdue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Component Tracing"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Environment/Facilities"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Equipment Damage"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Human Factor/Fatigue"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Incoming Inspection Finding"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Incorrect maintenance data"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Inventory Record Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Life Expired Part"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Maintenance Error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Modification Control Failure"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Segregation of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Technical Record"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Unapproved Repair/Misapplication"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Unknown or Suspect Origin of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Workshop",
    "classification": "Unusual Defect of Parts"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Individual Actions"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Temperature"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Visibility"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Weather"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Skill-Based Errors"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "Sensory Misperception"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "State of Mind"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Misconduct"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Violations"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Uncorrected Problem"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Roster"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Shift"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Sleep Disturbed"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Staff Fatigue/Stress"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Irregularity Report",
    "type": "Conflict",
    "classification": "Staff Conflict"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Irregularity Report",
    "type": "Medical",
    "classification": "Medical"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Procedural error"
  },
  {
    "area": "Engineering and Maintenance Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Non availability of staff"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Access to aircraft",
    "classification": "Aircraft Airbridge"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Access to aircraft",
    "classification": "Airstairs/Steps/Other Equipment"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Air Conditioning / ACU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Air Start / ASU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Aircraft damage discovered"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Chocking"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Coning"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Ground Power / GPU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Cargo straps used incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Cargo/Baggage loaded in incorrect position"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Cargo/Baggage/Mail dropped from GSE/aircraft"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Ground stability -Tipping / Tail Tipping"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Hold Ceiling Limits"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Load found from previous sector"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Loading not in Accordance with Loadplan"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Nets not raised"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Over carriage of cargo/baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Segregation rules not followed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "SOP not followed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Spillage of Load"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Uncommanded Movement"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Unsecured Baggage in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading",
    "classification": "Unsecured Cargo in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Aircraft brakes released without clearance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Communication Failure"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Nose wheel light flashed blinding tractor"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Pushback Procedural Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Steering/Ground Lock Pin"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Struck by Pushback/Towing Equipment/Vehicle"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Struck by Pushed/Towed Aircraft"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Towbar Shear Pin Failed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Tractor - Defective"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Undercarriage Pin found Installed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Wing Struck Object while on Tow"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Catering"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "De-Icing"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "External Wash"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Defective Vehicle/Equipment"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Procedural Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Removed when hose was connected"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Spillage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Interior Cleaning"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "PAU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Toilet Service"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Servicing",
    "classification": "Water Service / Temiz Su Servisi"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Baggage Excess"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Baggage weight discrepancy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Equipment Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Handling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Incorrectly tagged"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Baggage",
    "classification": "Transfer Baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cabin Baggage",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cabin Baggage",
    "classification": "Oversized/Overweight cabin baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cabin Baggage",
    "classification": "Prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cabin Baggage",
    "classification": "Smoke/Fire/Fumes"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cabin Baggage",
    "classification": "Undeclared/Hidden/Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Catering",
    "classification": "Catering service standarts"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Catering",
    "classification": "Catering truck- incorrectly positioned"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Catering",
    "classification": "Catering truck-Approaching & Removed Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Catering",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Checked Baggage",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Checked Baggage",
    "classification": "Oversized/Overweight checked baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Checked Baggage",
    "classification": "Prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Checked Baggage",
    "classification": "Smoke/Fire/Fumes"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Checked Baggage",
    "classification": "Undeclared/Hidden/Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Coordination Error",
    "classification": "Coordination Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods",
    "classification": "Incorrect/Insufficent loading"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods",
    "classification": "Late information provided - NOTOC/Special load data"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods",
    "classification": "Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods",
    "classification": "Missing/Incorrect preparation of NOTOC/Special Load"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods",
    "classification": "Undeclared/Hidden"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Documentation",
    "classification": "Documentation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "External Security Service",
    "classification": "External Security Service Irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fire Service",
    "classification": "Fire truck irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fuel Service",
    "classification": "Fuel documantation error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fuel Service",
    "classification": "Fuel errors (fuel figures/distribution)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fuel Service",
    "classification": "Fuel Spill"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fuel Service",
    "classification": "Fuel truck incorrectly positioned"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fuel Service",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fuel Service",
    "classification": "Refuelling Standards"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin Crew - Deployed Slide"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin Crew - Door Opened without Equipment in Position"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin door left open without ground equipment"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin door operated incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground / Cabin Interface",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground / Cabin Interface",
    "classification": "Unauthorised door operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Approach aircraft with anti-collision beacon/engine on"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Brake check not performed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision GSE to GSE"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision GSE to personnel"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision GSE to stationary aircraft"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision with airport infrastructure"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Equipment guideman failure"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Equipment positioned incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Equipment/Vehicle left - Unattended"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Lack & Late of GSE"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Maneuvering"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "No Touch Policy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Parking of GSE"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Passenger steps removed - door left open"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Speeding"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Unauthorized driving under aircraft wing"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Lack & Late of Agent / Personel",
    "classification": "Lack & Late of Agent"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Movement Messages Irregularities",
    "classification": "Movement Messages Irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Baggage Acceptance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Boarding pass discrepancy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Check-in"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Discrepancy in Passenger Numbers"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Failure to check travel documentation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Inappropriate Seat Allocation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Incorrect male - female - child count"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Infant/Child incorrect acceptance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger - Undeclared Dangerous Goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger - Undeclared Firearm"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Acceptance/Check-In"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Boarded - Live Animal"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Boarded - With prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Boarded - Wrong Flight"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Failed to Board - Bag in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Handling Vehicle - Defective"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Injured"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger Offloaded - Bag in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Passenger offloaded/not accepted due to medical condition"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Procedure Error - Passenger handling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Special Category Passenger"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Special needs passenger related (PRM)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Struck by Passenger Handling Vehicle"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Transfer Passenger"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Travel document discrepancy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Passenger Handling",
    "classification": "Unaccompanied minors incorrect acceptance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "Equipment over restraint line"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "FOD in tyre"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "FOD on ramp"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "Marshalling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "Personnel over restraint line"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "Pre-arrival checks/briefing not performed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Pre-Arrival",
    "classification": "Walk Around Check"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "PRM Service",
    "classification": "PRM Equipment Irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "PRM Service",
    "classification": "Transportation/Service Error for PRM Passenger"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Fuel figure errors"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect aircraft parameters"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect LMC"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect passenger number"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect weight"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Late delivery of flight documents"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Loadsheet discrepancy - incorrect data"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Loadsheet discrepancy - load distribution"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "LS/LIR mismatch"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Outside limits"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Weight/Balance limitation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Production of Load Sheet",
    "classification": "Wrong DOW/DOI calculation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "Door Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "Engine Hazard"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "Ground Support Equipment Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "Loading Errors"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "Spill"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ramp Handling",
    "classification": "ULD Movement and Transport"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Terminal Service",
    "classification": "Air Bridge - Guidance System"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Terminal Service",
    "classification": "Approaching & Removed Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Terminal Service",
    "classification": "Incorrect stand guidance system alignmen"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Terminal Service",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Terminal Service",
    "classification": "Parking position availability"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Terminal Service",
    "classification": "Potable Water Services"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Ticket Sales Services",
    "classification": "Ticket Sales Services"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Aircraft Hold Loading / Unloading",
    "classification": "Unsecured Cargo in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cargo",
    "classification": "Shipment damage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Cargo",
    "classification": "ULD Build"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Compliance Observations",
    "classification": "Rules and Regulations"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods Handling",
    "classification": "Spillage/Leakage /Release dangerous goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods Handling",
    "classification": "State/Carrier variation not complied with"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Dangerous Goods Handling",
    "classification": "Undeclared/Hidden dangerous goods in cargo"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fatigue",
    "classification": "Roster"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Fatigue",
    "classification": "Staff Fatigue/Stress"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Loading Errors",
    "classification": "Special cargo loaded incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Loading Errors",
    "classification": "Spill/Leak - Non dangerous goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Planning LIR",
    "classification": "Segregation rules not followed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Product",
    "classification": "Recommendations or Observations"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Service Supplier/Contracted Activities",
    "classification": "Recommendations or Observations"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Special Cargo Handling",
    "classification": "Spillage/Leakage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Special Cargo Handling",
    "classification": "Suspicious package/object"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Special Cargo Handling",
    "classification": "Undeclared/Hidden"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Training Activities",
    "classification": "The training content is not up-to-date"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Training Activities",
    "classification": "The training plan is not up-to-date"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Individual Actions"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Temperature"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Visibility"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Weather"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Skill-Based Errors"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "Sensory Misperception"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "State of Mind"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Misconduct"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Violations"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Uncorrected Problem"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Access to aircraft",
    "classification": "Aircraft Airbridge"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Access to aircraft",
    "classification": "Airstairs/Steps/Other Equipment"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Air Conditioning / ACU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Air Start / ASU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Aircraft damage discovered"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Chocking"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Coning"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Ground Power / GPU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Cargo straps used incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Cargo/Baggage loaded in incorrect position"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Cargo/Baggage/Mail dropped from GSE/aircraft"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Ground stability -Tipping / Tail Tipping"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Hold Ceiling Limits"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Load found from previous sector"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Loading not in Accordance with Loadplan"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Nets not raised"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Over carriage of cargo/baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Segregation rules not followed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "SOP not followed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Spillage of Load"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Uncommanded Movement"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Unsecured Baggage in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading",
    "classification": "Unsecured Cargo in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Aircraft brakes released without clearance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Communication Failure"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Nose wheel light flashed blinding tractor"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Pushback Procedural Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Steering/Ground Lock Pin"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Struck by Pushback/Towing Equipment/Vehicle"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Struck by Pushed/Towed Aircraft"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Towbar Shear Pin Failed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Tractor - Defective"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Undercarriage Pin found Installed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Pushback/Towing / Pushback/Towing",
    "classification": "Wing Struck Object while on Tow"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Catering"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "De-Icing"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "External Wash"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Defective Vehicle/Equipment"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Procedural Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Removed when hose was connected"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Fuelling - Spillage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Interior Cleaning"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "PAU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Toilet Service"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Servicing",
    "classification": "Water Service / Temiz Su Servisi"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Baggage Excess"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Baggage weight discrepancy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Equipment Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Handling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Incorrectly tagged"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Baggage",
    "classification": "Transfer Baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cabin Baggage",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cabin Baggage",
    "classification": "Oversized/Overweight cabin baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cabin Baggage",
    "classification": "Prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cabin Baggage",
    "classification": "Smoke/Fire/Fumes"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cabin Baggage",
    "classification": "Undeclared/Hidden/Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Catering service standarts"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Catering truck- incorrectly positioned"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Catering truck-Approaching & Removed Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Catering",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Checked Baggage",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Checked Baggage",
    "classification": "Oversized/Overweight checked baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Checked Baggage",
    "classification": "Prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Checked Baggage",
    "classification": "Smoke/Fire/Fumes"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Checked Baggage",
    "classification": "Undeclared/Hidden/Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Coordination Error",
    "classification": "Coordination Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Incorrect/Insufficent loading"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Late information provided - NOTOC/Special load data"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Missing/Incorrect preparation of NOTOC/Special Load"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Undeclared/Hidden"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Documentation",
    "classification": "Documentation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "External Security Service",
    "classification": "External Security Service Irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fire Service",
    "classification": "Fire truck irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fuel Service",
    "classification": "Fuel documantation error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fuel Service",
    "classification": "Fuel errors (fuel figures/distribution)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fuel Service",
    "classification": "Fuel Spill"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fuel Service",
    "classification": "Fuel truck incorrectly positioned"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fuel Service",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Fuel Service",
    "classification": "Refuelling Standards"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin Crew - Deployed Slide"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin Crew - Door Opened without Equipment in Position"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin door left open without ground equipment"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground / Cabin Interface",
    "classification": "Cabin door operated incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground / Cabin Interface",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground / Cabin Interface",
    "classification": "Unauthorised door operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Approach aircraft with anti-collision beacon/engine on"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Brake check not performed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision GSE to GSE"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision GSE to personnel"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision GSE to stationary aircraft"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Collision with airport infrastructure"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Equipment guideman failure"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Equipment positioned incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Equipment/Vehicle left - Unattended"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Lack & Late of GSE"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Maneuvering"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "No Touch Policy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Parking of GSE"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Passenger steps removed - door left open"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Speeding"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ground Support Equipment Operation",
    "classification": "Unauthorized driving under aircraft wing"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Lack & Late of Agent / Personel",
    "classification": "Lack & Late of Agent"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Movement Messages Irregularities",
    "classification": "Movement Messages Irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Baggage Acceptance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Boarding pass discrepancy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Check-in"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Discrepancy in Passenger Numbers"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Failure to check travel documentation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Inappropriate Seat Allocation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Incorrect male - female - child count"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Infant/Child incorrect acceptance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger - Undeclared Dangerous Goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger - Undeclared Firearm"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Acceptance/Check-In"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Boarded - Live Animal"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Boarded - With prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Boarded - Wrong Flight"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Failed to Board - Bag in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Handling Vehicle - Defective"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Injured"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger Offloaded - Bag in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Passenger offloaded/not accepted due to medical condition"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Procedure Error - Passenger handling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Special Category Passenger"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Special needs passenger related (PRM)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Struck by Passenger Handling Vehicle"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Transfer Passenger"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Travel document discrepancy"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Passenger Handling",
    "classification": "Unaccompanied minors incorrect acceptance"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "Equipment over restraint line"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "FOD in tyre"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "FOD on ramp"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "Marshalling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "Personnel over restraint line"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "Pre-arrival checks/briefing not performed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Pre-Arrival",
    "classification": "Walk Around Check"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "PRM Service",
    "classification": "PRM Equipment Irregularities"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "PRM Service",
    "classification": "Transportation/Service Error for PRM Passenger"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Fuel figure errors"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect aircraft parameters"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect LMC"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect passenger number"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Incorrect weight"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Late delivery of flight documents"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Loadsheet discrepancy - incorrect data"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Loadsheet discrepancy - load distribution"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "LS/LIR mismatch"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Outside limits"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Weight/Balance limitation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of Load Sheet",
    "classification": "Wrong DOW/DOI calculation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "Door Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "Engine Hazard"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "Ground Support Equipment Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "Loading Errors"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "Spill"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ramp Handling",
    "classification": "ULD Movement and Transport"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Air Bridge - GPU"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Air Bridge - Guidance System"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Approaching & Removed Error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Incorrect stand guidance system alignmen"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Parking position availability"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Terminal Service",
    "classification": "Potable Water Services"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Ticket Sales Services",
    "classification": "Ticket Sales Services"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Aircraft Hold Loading / Unloading",
    "classification": "Unsecured Cargo in Hold"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Cargo - Undeclared Dangerous Goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Cargo - Undeclared Firearm"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Equipment Operation"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Handling"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Hidden/Misdeclared dangerous goods in cargo"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Late presentation of cargo"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Prohibited items"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "Shipment damage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Cargo",
    "classification": "ULD Build"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods",
    "classification": "Dangerous Goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Checklist not performed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Damage (no release)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Incorrect/Insufficient load spreading"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Incorrect/Insufficient packaging"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Incorrect/Missing/Illegible labelling/Marking"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Misdeclared dangerous goods in cargo"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Not segregated correctly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Spillage/Leakage /Release dangerous goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "State/Carrier variation not complied with"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods Handling",
    "classification": "Undeclared/Hidden dangerous goods in cargo"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods/Special Load Documentation",
    "classification": "Late information provided - NOTOC/Special load data"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods/Special Load Documentation",
    "classification": "Missing/Incorrect preparation of NOTOC/Special Load"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Dangerous Goods/Special Load Documentation",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Cargo loaded - Wrong Flight"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Cargo/Baggage loaded in incorrect position"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Dangerous goods loaded incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Over carriage of cargo/baggage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Special cargo loaded incorrectly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Loading Errors",
    "classification": "Spill/Leak - Non dangerous goods"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Planning LIR",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Planning LIR",
    "classification": "Segregation rules not followed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of LS and/or LIR, Manifest",
    "classification": "Incorrect Cargo weight"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of LS and/or LIR, Manifest",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Production of LS and/or LIR, Manifest",
    "classification": "Outside Cargo limits (which is not within the defined Airline limits)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Checklist not performed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Damage (no spill/leak)"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Incorrect/Insufficient packaging"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Incorrect/Missing/Illegible labelling/Marking"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Misdeclared"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Not segregated correctly"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Spillage/Leakage"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Suspicious package/object"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Occurrence Report",
    "type": "Special Cargo Handling",
    "classification": "Undeclared/Hidden"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Roster"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Shift"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Sleep Disturbed"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Fatigue Report",
    "type": "Fatigue",
    "classification": "Staff Fatigue/Stress"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Irregularity Report",
    "type": "Conflict",
    "classification": "Staff Conflict"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Irregularity Report",
    "type": "Medical",
    "classification": "Medical"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Procedural error"
  },
  {
    "area": "Ground and Cargo Operations Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Non availability of staff"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Access Control",
    "classification": "Security Restricted Areas"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Criminal Acts",
    "classification": "Human Trafficking"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Criminal Acts",
    "classification": "Wildlife Trafficking"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Criminal Acts",
    "classification": "Passenger Disturbances"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Safeguarding and screening",
    "classification": "Staff and Crew Screening"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Threat/Interference",
    "classification": "Sabotage"
  },
  {
    "area": "Security Report",
    "kind": "Occurrence Report",
    "type": "Unauthorised Weapons",
    "classification": "Weapons/Armed Individuals Transportation"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Access Control",
    "classification": "Security Restricted Areas"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Criminal Acts",
    "classification": "Human Trafficking"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Criminal Acts",
    "classification": "Wildlife Trafficking"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Criminal Acts",
    "classification": "Passenger Disturbances"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Safeguarding and screening",
    "classification": "Staff and Crew Screening"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Threat/Interference",
    "classification": "Sabotage"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Unauthorised Weapons",
    "classification": "Weapons/Armed Individuals Transportation"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Individual Actions"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Temperature"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Visibility"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Environmental",
    "classification": "Weather"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Individual Actions",
    "classification": "Skill-Based Errors"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "Sensory Misperception"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Preconditions",
    "classification": "State of Mind"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Misconduct"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Supervisory Violations"
  },
  {
    "area": "Security Report",
    "kind": "Hazard Report",
    "type": "Supervision",
    "classification": "Uncorrected Problem"
  },
  {
    "area": "Security Report",
    "kind": "Irregularity Report",
    "type": "Conflict",
    "classification": "Passenger Disturbances"
  },
  {
    "area": "Security Report",
    "kind": "Irregularity Report",
    "type": "Conflict",
    "classification": "Staff Conflict"
  },
  {
    "area": "Security Report",
    "kind": "Irregularity Report",
    "type": "Medical",
    "classification": "Medical"
  },
  {
    "area": "Security Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Other"
  },
  {
    "area": "Security Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Procedural error"
  },
  {
    "area": "Security Report",
    "kind": "Irregularity Report",
    "type": "Other",
    "classification": "Non availability of staff"
  }
];
